export var defaultConfig = {
    tokenKey: 'localStorage.accessToken',
    appBaseUrl: '/',
    appIdentifier: 'a6ad46aa91d37d427ee2a7a424c65bcd9c18d1ba3d7fc029eb111be67246',
    customerSecretKey: '572d366bda2f3aec348d2a202c422b7ab451b4b9cc0995f87723e2544b3c',
    // appIdentifier: '76bbd2244be392ae0c9ae4e22dcc98c07e0e25c6886b8df573e3ce6fbd7b',
    // customerSecretKey: 'a8817fcaf5224f3945cfe2e055e626bce529d1b0693d0597d0d4ac2df88d',
    apiBaseUrl: 'https://iam.api.dev.vriti.ai',
    shouldIncludeAdminModule: true,
    logo: {
        mobileLoginPageLogo: '/mobile-login-logo.png',
        mobileSignupPageLogo: '/mobile-signup-logo.png',
    },
    authRoutes: [
        {
            name: 'Home',
            path: '/',
        },
    ],
    userTypeId: 53,
    groupId: 33,
    userRoleId: 16,
    // userTypeId: 73,
    // groupId: 856,
    // userRoleId: 1626,
    productName: 'vriti',
    forgetPassword: true,
    SignUpOptions: false,
    LoginUpOptions: false,
    // signupRoute: 'https://dev.backend.vriti.ai/api/v2/auth/candidate-signup/',
    signupRoute: '/user/signup',
    isExistsRoute: '/user/is-exists',
    sendVerifyEmailOtpRoute: '/user/send-verify-email-otp',
    verifyEmailRoute: '/user/verify-email',
    loginRoute: '/user/login',
    validateTokenRoute: '/user/validate-token',
    forgetPasswordSendEmailRoute: 'user/forgot-password-send-mail',
    forgetPasswordVerifyTokenRoute: '/user/forgot-password-verify-token',
    forgetPasswordUpdatePasswordRoute: '/user/forgot-password-update-password',
    googleAuth: {
        enabled: true,
        flowType: 'redirect',
        endpoint: '/user/auth/google',
        // endpoint: 'https://dev.backend.vriti.ai/api/v2/auth/google',
        // sideEffectEndpoint: 'https://dev.backend.vriti.ai/api/v2/auth/google-signup/',
    },
    linkedinAuth: {
        enabled: true,
        flowType: 'redirect',
        endpoint: '/user/auth/linkedin',
        // endpoint: 'https://dev.backend.vriti.ai/api/v2/auth/linkedin',
        // sideEffectEndpoint: 'https://dev.backend.vriti.ai/api/v2/auth/linkedin-signup/',
    },
    dynamicFields: [
        {
            name: 'name',
            label: 'Name',
            type: 'text',
            required: true,
            placeholder: 'Enter your name',
        },
        {
            name: 'email',
            label: 'Email ID',
            type: 'email',
            required: true,
            placeholder: 'Enter your email',
        },
        {
            name: 'mobile',
            label: 'Mobile Number',
            type: 'tel',
            placeholder: 'Enter your mobile number',
        },
    ],
    // dynamicFields: [
    //   {
    //     label: 'Account Type',
    //     name: 'account_type',
    //     type: 'text',
    //     defaultValue: 'candidate',
    //     isDefault: true,
    //   },
    //   {
    //     label: 'user_objective',
    //     name: 'user_objective',
    //     type: 'text',
    //     defaultValue: 'finding_job',
    //     isDefault: true,
    //   },
    //   {
    //     label: 'last_name',
    //     name: 'last_name',
    //     type: 'text',
    //     defaultValue: '',
    //     isDefault: true,
    //   },
    //   {
    //     label: 'Name',
    //     name: 'first_name',
    //     type: 'text',
    //     required: true,
    //   },
    //   {
    //     label: 'Email',
    //     name: 'email',
    //     type: 'email',
    //     required: true,
    //   },
    //   {
    //     "name": "file",
    //     "label": "File",
    //     "type": "file",
    //     "options": [],
    //     "required": true,
    //     "isDefault": false,
    //     "placeholder": "",
    //     'sideEffectUrl': "https://dev.backend.vriti.ai/api/v2/candidate-upload-resume/"
    // }
    //   {
    //     "name": "gender",
    //     "label": "gender",
    //     "type": "dropdown",
    //     "options": [],
    //     "required": true,
    //     "isDefault": false,
    //     "placeholder": "",
    //     "dataFromApi": true,
    //     "defaultValue": "",
    //     "apiEndpoint": "http://localhost:4000/options"
    // }
    // ],
};
